import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Lap } from "./GrandPrix.types";
import { animated, useTransition } from "react-spring";

const GrandPrixLaps = ({
  laps,
  showDetails,
  rally,
  classFilter,
}: {
  laps: Lap[];
  showDetails: boolean;
  rally?: any;
  classFilter?: string | null;
}) => {
  const { t } = useTranslation();
  const [valid, setValid] = useState(false);
  const [showSectors, setShowSectors] = useState(false);
  useEffect(() => {
    setValid(showDetails);
  }, [showDetails]);

  const legsCount = rally != null ? rally[rally.length - 1].leg : 0;
  const transition = useTransition(valid, {
    from: { height: 0, opacity: 0 },
    enter: {
      height:
        laps != null && laps.length > 0
          ? laps.length * 21.5 + 27 + legsCount * 12
          : 0, //laps*lap_height + header
      opacity: 1,
    },
    leave: { height: 0, opacity: 1 },
  });

  const hasTiresData = (laps: Lap[]) => {
    return laps.reduce((previous, lap) => {
      if (lap.tyreWear.fl.value != null) return true;
      return previous;
    }, false);
  };

  const hasFuelData = (laps: Lap[]) => {
    return laps.reduce((previous, lap) => {
      if (lap.fuel.value != null && lap.fuel.value != "NaN%") return true;
      return previous;
    }, false);
  };

  const renderLeg = (index: number) => {
    if (rally == null) return null;
    if (index === 0 || rally[index].leg !== rally[index - 1].leg) {
      return (
        <div className="gp-leg-full">
          {t("Leg").toUpperCase()} {rally[index].leg}
        </div>
      );
    }
    return null;
  };

  const getLapName = (index: number) => {
    if (rally != null) return rally[index].name;
    return `${t("Lap")} ${laps[index].num}`;
  };
  if (laps == null || laps.length == 0) return <></>;
  return transition((style, item) => {
    return (
      item && (
        <animated.div style={style} className="gp-driver-laps">
          <div className="gp-driver-laps-header flex text-center">
            <div className="gp-driver-laps-pos" title={t("Position")}>
              #
            </div>
            {laps[0].driver_name != "" && (
              <div className="gp-driver-laps-lap">{t("Driver")}</div>
            )}
            <div className="gp-driver-laps-lap">{t("Lap")}</div>
            <div className="gp-driver-laps-time">{t("Time")}</div>
            <div className="gp-driver-laps-gap">{t("Gap")}</div>
            {showSectors && (
              <>
                <div className="gp-driver-laps-sector">{t("Sector")} 1</div>
                <div className="gp-driver-laps-sector">{t("Sector")} 2</div>
                <div className="gp-driver-laps-sector">{t("Sector")} 3</div>
              </>
            )}
            {hasTiresData(laps) && (
              <div className="gp-driver-laps-tyres">{t("Tyres")}</div>
            )}
            {hasFuelData(laps) && (
              <div className="gp-driver-laps-fuel">{t("Fuel")}</div>
            )}
          </div>
          {laps.map((lap: Lap, index: number) => {
            if (!showSectors && laps[index].sectors.s1 != "")
              setShowSectors(true);
            return (
              <React.Fragment key={lap.num}>
                {renderLeg(index)}
                <div
                  style={{
                    color:
                      classFilter == null
                        ? laps[index].colorGral
                        : laps[index].color,
                  }}
                  className={`gp-driver-laps-times flex text-center ${
                    lap.penalty != "" && lap.penalty != null ? "penalty" : ""
                  }`}
                  title={
                    lap.penalty != "" && lap.penalty != null
                      ? `${t("Penalty")}: +${parseInt(lap.penalty)}s`
                      : ""
                  }
                >
                  <div className="gp-driver-laps-pos">
                    <label>
                      {classFilter == null
                        ? laps[index].posGral
                        : laps[index].pos}
                    </label>
                  </div>

                  {laps[0].driver_name != "" && (
                    <div className="gp-driver-laps-lap">
                      {laps[index].driver_name}
                    </div>
                  )}
                  <div className="gp-driver-laps-lap">
                    <label>{getLapName(index)}</label>
                  </div>
                  <div className="gp-driver-laps-time relative">
                    <label>{laps[index].time}</label>
                    {laps[index].isSuperRally && <span className="sr">SR</span>}
                  </div>
                  <div className="gp-driver-laps-gap">
                    <label>
                      {classFilter == null
                        ? laps[index].gapGral
                        : laps[index].gap}
                    </label>
                  </div>
                  {showSectors && (
                    <>
                      <div className="gp-driver-laps-sector">
                        <label>{laps[index].sectors.s1}</label>
                      </div>
                      <div className="gp-driver-laps-sector">
                        <label>{laps[index].sectors.s2}</label>
                      </div>
                      <div className="gp-driver-laps-sector">
                        <label>{laps[index].sectors.s3}</label>
                      </div>
                    </>
                  )}
                  {hasTiresData(laps) && (
                    <div className="gp-driver-laps-tyres">
                      {laps[index].tyreWear.rl.value != null && (
                        <div className="wear-container flex-center">
                          <img
                            src={require(`../../assets/Images/TyresCar.png`)}
                            alt={t("Car")}
                          />
                          <span
                            className="gp-tyre-rl"
                            style={{ color: laps[index].tyreWear.rl.color }}
                          >
                            {laps[index].tyreWear.rl.value}
                          </span>
                          <span
                            className="gp-tyre-rr"
                            style={{ color: laps[index].tyreWear.rr.color }}
                          >
                            {laps[index].tyreWear.rr.value}
                          </span>
                          <span
                            className="gp-tyre-fl"
                            style={{ color: laps[index].tyreWear.fl.color }}
                          >
                            {laps[index].tyreWear.fl.value}
                          </span>
                          <span
                            className="gp-tyre-fr"
                            style={{ color: laps[index].tyreWear.fr.color }}
                          >
                            {laps[index].tyreWear.fr.value}
                          </span>
                          {laps[index].compounds.rear != null && (
                            <img
                              title={laps[index].compounds.rear.toUpperCase()}
                              className="tyre-image rear-compound"
                              src={`/assets/Tyres/${laps[index].compounds.rear}.png`}
                            />
                          )}
                          {laps[index].compounds.front != null && (
                            <img
                              title={laps[index].compounds.front.toUpperCase()}
                              className="tyre-image front-compound"
                              src={`/assets/Tyres/${laps[index].compounds.front}.png`}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {hasFuelData(laps) && (
                    <div className="gp-driver-laps-fuel flex-center">
                      {laps[index].fuel.value != "NaN%" && (
                        <>
                          <div
                            className="bar-fuel"
                            style={{
                              background: `linear-gradient(0deg, ${laps[index].fuel.color} 66%, rgb(0 0 0)100%)`,
                              width: laps[index].fuel.value,
                            }}
                          ></div>
                          <label>{laps[index].fuel.value}</label>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </React.Fragment>
            );
          })}
        </animated.div>
      )
    );
  });
};

export default GrandPrixLaps;
